import React, { useState } from 'react';
import { t } from '../../../i18n/t';
import MContext from '../../../models/MContext';
import { MAX_PAGE_SIZE, SearchEntity } from '../../../utils/Constants';
import DecoratorConstants from '../../../utils/DecoratorConstants';
import Services from '../../../utils/Services';
import { buildSearchCondition } from '../../search/SearchUtils';
import MultiSelectFilterComponent from './MultiSelectFilterComponent';

const JiraPriorityFilter = (props) => {

  const [multiOptions, setMultiOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFirstOpen, setFirstOpen] = useState(true);

  const getOptions = () => {
    const projectId = MContext.projectId;
    setLoading(true);
    const params = {
      pagination: {
        page: 0,
        size: MAX_PAGE_SIZE,
        sorts: ['priority,asc'],
      },
      conditions: [
        buildSearchCondition('Project.id', '=', projectId),
        buildSearchCondition('deleted', '=', false),
        buildSearchCondition('migrationError', 'is null', '')
      ],
      type: SearchEntity.ExternalDefect,
      groupBys: ['priority']
    };

    Services.searchRecursively(0, params, []).then((res) => {
      const multiOptions = res.map(({ content }) => {
        const { priority } = content;
        return { priority };
      });
      setMultiOptions(multiOptions);
      setLoading(false);
      setFirstOpen(false);
    });
  };

  const onOpen = () => {
    if (isFirstOpen) {
      getOptions();
    }
  };

  const renderOption = (option) => DecoratorConstants.defectPriorityDecoratorWithoutIcon(option);

  return (
    <MultiSelectFilterComponent
      multiOptions={multiOptions}
      renderOption={renderOption}
      loading={loading}
      onOpen={onOpen}
      searchKey="priority"
      label={t('jira-filter#priority-label')}
      {...props}
    />
  );

};

export default JiraPriorityFilter;
